
export function openSocialMedia(platform: 'tiktok' | 'instagram' | 'twitter'): void {
  let url = '';
  const shareText = encodeURIComponent('#matchmylogic');
  
  if (platform === 'tiktok') {
    url = `https://www.tiktok.com/@matchmylogic`;
  } else if (platform === 'instagram') {
    url = `https://www.instagram.com/matchmylogic`;
  } else if (platform === 'twitter') {
    url = `https://twitter.com/intent/tweet?text=${shareText}`;
  }
  
  window.open(url, '_blank');
}
